export const siteTitle = {
  hu: "Juhász testvérek • Tradícionális pincészet • Egerszalók",
  en: "Juhász testvérek • Traditional Wine Cellar • Egerszalók"
}